import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Navbar from '../navbar/Navbar';
import ProfessionalPlanCard from '../layout/cards/ProfessionalPlanCard';
import CustomPlanCard from '../layout/cards/CustomPlanCard';
import '../../css/planAndPricing/paidPlans.css';

const PaidPlans = () => {
  const [plans, setPlans] = useState([]);
  const [professionalPlanPrice, setProfessionalPlanPrice] = useState(null);
  const [planId, setPlanId] = useState(null);

  // Fetch subscription plans using axios
  useEffect(() => {
    const fetchPlans = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URI}/ecomnext/api/subscription-plan-list`
        );
        const { subscriptionPlans } = response.data;

        if (subscriptionPlans) {
          setPlans(subscriptionPlans);

          // Find the price for the Professional Plan
          const professionalPlan = subscriptionPlans.find(
            (plan) => plan.name === 'Professional Plan'
          );
          if (professionalPlan) {
            setProfessionalPlanPrice(professionalPlan.price);
            setPlanId(professionalPlan.plan_id);
          }
        }
      } catch (error) {
        console.error('Error fetching subscription plans:', error);
      }
    };

    fetchPlans();
  }, []);

  return (
    <div className='pricing-plans-background flex flex-col min-h-screen'>
      {/* Navbar */}
      <Navbar />

      {/* Main Content */}
      <div className='flex-1 flex flex-col items-center px-4 py-8'>
        {/* Heading */}
        <h1 className='pricing-page-heading text-center leading-tight'>
          Find the <span className='heading-colored'>Perfect Plan</span> for{' '}
          <br />
          Your Business Needs
        </h1>

        {/* Cards Section */}
        <div className='grid grid-cols-1 md:grid-cols-2 gap-14'>
          {/* Professional Plan Card */}
          <div className='flex justify-center'>
            <ProfessionalPlanCard
              price={professionalPlanPrice}
              plan_id={planId}
            />
          </div>

          {/* Custom Plan Card */}
          <div className='flex justify-center'>
            <CustomPlanCard />
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaidPlans;
